import { Component, Input } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastService } from "@app/presentation/services/toast.service";
import { DialogOverlayComponent } from "../ui/dialog-overlay/dialog-overlay.component";
import { ButtonComponent } from "../ui/button/button.component";
import { Copy } from "lucide-angular";

@Component({
  standalone: true,
  imports: [ButtonComponent, TranslateModule, DialogOverlayComponent],
  templateUrl: "./dialog-share-in-web-desktop.component.html",
  styleUrls: ["./dialog-share-in-web-desktop.component.scss"],
  selector: "dialog-share-in-web-desktop",
})
/**
 * Dialog component. It is used to show a dialog with a title and a message.
 * By default it has two buttons: one to cancel the action and another to confirm it.
 * Otherwise, you can add custom buttoms.
 */
export class DialogShareInWebDesktopComponent {
  @Input() data = {
    message: "message",
    url: "url",
  };
  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  readonly copyIcon = Copy;

  get messageComplete() {
    return `${this.data.message}\n${this.data.url}`.trim();
  }

  closeDialog() {
    this.activeModal.close();
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.messageComplete);

    this.toastService.showInfo(
      this.translateService.instant("copy_to_clipboard.copiedToClipboard"),
      1000
    );
  }
}
